import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import { setUnauthorizedHandler } from "./lib/api.js";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 10_000,
    },
  },
});

// A 401 from any non-auth endpoint means the session is no longer valid.
setUnauthorizedHandler(() => {
  queryClient.setQueryData(["session"], null);
  // Keep the document (and any in-memory drafts) alive when a session expires.
  queryClient.removeQueries({ predicate: (query) => query.queryKey[0] !== "session" });
});

const container = document.getElementById("root");
if (!container) throw new Error("Root container #root not found.");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
